import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/user-6.jpg'
import _imports_1 from '@/assets/images/user-7.jpg'
import _imports_2 from '@/assets/images/user-8.jpg'
import _imports_3 from '@/assets/images/user-9.jpg'
import _imports_4 from '@/assets/images/user-10.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "default-table-area manage-reviews-table" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }
const _hoisted_6 = { class: "d-flex align-items-center gap-3" }
const _hoisted_7 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_8 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_9 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_10 = { class: "d-flex align-items-center gap-3" }
const _hoisted_11 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_12 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_13 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_14 = { class: "d-flex align-items-center gap-3" }
const _hoisted_15 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_16 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_17 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_18 = { class: "d-flex align-items-center gap-3" }
const _hoisted_19 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_20 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_21 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_22 = { class: "d-flex align-items-center gap-3" }
const _hoisted_23 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_24 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_25 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Manage Reviews")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[35] || (_cache[35] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Reviewer"),
                _createElementVNode("th", { scope: "col" }, "Review"),
                _createElementVNode("th", { scope: "col" }, "Date"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-40 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Olivia Clark"),
                        _createElementVNode("span", { class: "text-body" }, "olivia@trezo.com")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-lg-center flex-wrap gap-1 mb-2" }, [
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" })
                  ]),
                  _createElementVNode("p", { class: "mw-380" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. ")
                ], -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "d-block" }, "17 Dec 2024"),
                  _createElementVNode("span", { class: "d-block" }, "08:30 PM")
                ], -1)),
                _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal" }, " Pending ")
                ], -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " download_done ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Approved',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " reply ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Reply',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Delete',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-40 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Zephyr Zing"),
                        _createElementVNode("span", { class: "text-body" }, "zephyr@trezo.com")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-lg-center flex-wrap gap-1 mb-2" }, [
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-half-fill fs-18 text-warning" })
                  ]),
                  _createElementVNode("p", { class: "mw-380" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. ")
                ], -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "d-block" }, "17 Dec 2024"),
                  _createElementVNode("span", { class: "d-block" }, "08:30 PM")
                ], -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal" }, "Pending")
                ], -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "download_done", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Approved',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_12, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "reply", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Reply',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_13, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Delete',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-40 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Nova Nectar"),
                        _createElementVNode("span", { class: "text-body" }, "nova@trezo.com")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-lg-center flex-wrap gap-1 mb-2" }, [
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-line fs-18 text-warning" })
                  ]),
                  _createElementVNode("p", { class: "mw-380" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. ")
                ], -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "d-block" }, "17 Dec 2024"),
                  _createElementVNode("span", { class: "d-block" }, "08:30 PM")
                ], -1)),
                _cache[20] || (_cache[20] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal" }, " Pending ")
                ], -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_15, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " download_done ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Approved',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_16, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " reply ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Reply',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_17, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Delete',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-40 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Isabella Chang"),
                        _createElementVNode("span", { class: "text-body" }, "isabella@trezo.com")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-lg-center flex-wrap gap-1 mb-2" }, [
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-half-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-line fs-18 text-warning" })
                  ]),
                  _createElementVNode("p", { class: "mw-380" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. ")
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "d-block" }, "17 Dec 2024"),
                  _createElementVNode("span", { class: "d-block" }, "08:30 PM")
                ], -1)),
                _cache[27] || (_cache[27] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal" }, "Pending")
                ], -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_19, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "download_done", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Approved',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_20, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "reply", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Reply',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_21, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Delete',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-40 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2 ps-1" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Alina Bennett"),
                        _createElementVNode("span", { class: "text-body" }, "alina@trezo.com")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[32] || (_cache[32] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-lg-center flex-wrap gap-1 mb-2" }, [
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" }),
                    _createElementVNode("i", { class: "ri-star-fill fs-18 text-warning" })
                  ]),
                  _createElementVNode("p", { class: "mw-380" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. ")
                ], -1)),
                _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "d-block" }, "17 Dec 2024"),
                  _createElementVNode("span", { class: "d-block" }, "08:30 PM")
                ], -1)),
                _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal" }, " Published ")
                ], -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_23, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " download_done ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Approved',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_24, [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " reply ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Reply',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_25, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ", -1)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'Delete',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap\"><span class=\"fs-13 fw-medium\">Items per pages: 5</span><div class=\"d-flex align-items-center\"><span class=\"fs-13 fw-medium me-2\">1 - 5 of 12</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><a class=\"page-link icon\" href=\"#\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></a></li><li class=\"page-item\"><a class=\"page-link icon\" href=\"#\" aria-label=\"Next\"><i class=\"material-symbols-outlined\"> keyboard_arrow_right </i></a></li></ul></nav></div></div>", 1))
      ])
    ])
  ]))
}